import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'

import { logout } from '~api/services/core/users'
import { Button, Typography } from '~components/internal'
import { type RootState } from '~redux/rootReducer'
import { logoutUser } from '~redux/slices/authSlice'
import { type AppDispatch, persistor } from '~redux/store'
import { spacing } from '~tokens/internal'

interface SignOutDialogProps {
  open: boolean
  onClose: () => void
}

const SignOutDialog: React.FC<SignOutDialogProps> = ({ open, onClose }) => {
  const dispatch: AppDispatch = useDispatch()
  const userId = useSelector((state: RootState) => state?.auth.userId)
  const [isLoading, setIsLoading] = React.useState(false)

  const handleSignOut = async (): Promise<void> => {
    setIsLoading(true)
    try {
      if (userId) {
        await logout(userId)
      }
      dispatch(logoutUser())
    } catch (error) {
      console.error('Logout failed', error)
    } finally {
      await persistor.purge()
      dispatch({ type: 'RESET_STATE' })
      window.location.assign('/')
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Sign out</DialogTitle>
      <DialogContent>
        <Typography variant='body1'>Are you sure you want to sign out of Polimorphic?</Typography>
      </DialogContent>
      <DialogActions>
        <Stack
          direction='row'
          spacing={spacing.xxs}
          sx={{
            justifyContent: 'flex-end',
            width: '100%',
          }}
        >
          <Button variant='outlined' onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant='contained' color='error' onClick={handleSignOut} loading={isLoading}>
            Sign out
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default SignOutDialog
